import React from "react";
import ReactDOM from "react-dom";
import LodaerIcon from "../../assets/loadingIcon.gif"
const portalRoot = document.getElementById("portal");


export default function Loader() {
    return (ReactDOM.createPortal(<div className="loaderBackground">
        <div className='spinner sweet-loading'>
            <img alt="" style={{ maxHeight: 124, minHeight: 124, maxWidth: 124, minWidth: 124 }} src={LodaerIcon} />
        </div>
    </div>, portalRoot));
}